import { ShareServiceClient } from '@azure/storage-file-share'

const account = process.env.GATSBY_AZURE_UPLOAD_ACCOUNT_NAME
const shareName = process.env.GATSBY_AZURE_UPLOAD_MP_SHARE_NAME

export const UploadToAzure = async (sas, file, filePath) => {
  const serviceClientWithSAS = new ShareServiceClient(
    `https://${account}.file.core.windows.net${sas}`
  )
  const directoryClient = serviceClientWithSAS
    .getShareClient(shareName)
    .getDirectoryClient('')
  const fileClient = await directoryClient.getFileClient(filePath)
  await fileClient.uploadData(file)
}

export const GetUrl = filePath => {
  return `https://${account}.file.core.windows.net/${shareName}/${filePath}`
}

export const DeleteFile = async (sas, filePath) => {
  const serviceClientWithSAS = new ShareServiceClient(
    `https://${account}.file.core.windows.net${sas}`
  )
  const directoryClient = serviceClientWithSAS
    .getShareClient(shareName)
    .getDirectoryClient('')
  const fileClient = directoryClient.getFileClient(filePath)
  await fileClient.deleteIfExists(filePath)
}
